import { api } from './api.js';

// Poll GET /dialer/v1/script/extract/:jobId every `intervalMs` until status
// is done|failed or `timeoutMs` is reached. Resolves with the final job
// payload (caller distinguishes done vs failed by `.status`). Throws on
// timeout or a transport error that isn't a transient blip.
//
// Why polling: the POST endpoint returns 202 immediately so Whisper
// transcription (60–120s for long audio) can finish past Railway's ~100s
// edge timeout. See ScriptExtractJob model docstring for full context.
export async function pollExtractJob(
  jobId,
  { onStatusChange, intervalMs = 2000, timeoutMs = 10 * 60 * 1000 } = {},
) {
  const start = Date.now();
  let lastStatus = null;
  // eslint-disable-next-line no-constant-condition
  while (true) {
    if (Date.now() - start > timeoutMs) {
      throw new Error('extraction_timeout');
    }
    const r = await api.get(`/dialer/v1/script/extract/${jobId}`);
    const job = r.data || {};
    if (job.status !== lastStatus && typeof onStatusChange === 'function') {
      onStatusChange(job.status);
      lastStatus = job.status;
    }
    if (job.status === 'done' || job.status === 'failed') return job;
    await new Promise((res) => setTimeout(res, intervalMs));
  }
}
